import { styled } from 'next-yak';

import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { spaceXL, spaceXXL, space3XL } from '@xing-com/tokens';
import { Hero } from '@xing-com/typography';

export const PageTitleHeader = styled(Hero)`
  text-align: center;
  /* TODO: remove the !importants once migrated to next-yak as they are due to a CSS cascade order conflict */
  padding-top: ${space3XL} !important;
  padding-bottom: ${spaceXXL} !important;

  @media ${mediaSmallOrTiny} {
    padding-top: ${spaceXL} !important;
    padding-bottom: 0 !important;
  }
`;
